import React, { useState } from "react";
import { Button, Fade, TextField, Typography } from "@material-ui/core";
import "react-toastify/dist/ReactToastify.css";
import useStyles from "../../../../styles";
import { IconButton } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import { decryptData } from "../../../../crypto";
import axios from "axios";
import { toast } from "react-toastify";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import { useNavigate } from "react-router-dom";

const PlanPopup = (props) => {
  const { handleOpenClose, ids, exam_id } = props;
 const navigate = useNavigate();
  const classes = useStyles();
  const decryptedToken = decryptData(sessionStorage.getItem("token"));

  const [password, setPassword] = useState();
  const [showPassword, setShowPassword] = useState(false);

  const handleToggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleStatus = async () => {
    // Validation checks
    if (!password) {
      toast.error("Please enter a password.");
      return;
    }

    try {
      const checkPasswordData = {
        user: {
          password: password,
        },
      };

      // Step 1: Check if the password is valid
      const passwordCheckResponse = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/check/password`,
        checkPasswordData,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );

      // If the password check is not successful, notify the user and exit
      if (!passwordCheckResponse.data.success) {
        toast.error("Invalid password. Please try again.");
        return;
      }

      // Step 2: Restart all if the password check passes
      const restartResponse = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/live/restart/all`,
        {
          learner: {
            ids: ids,
            exam_id: exam_id,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );

      toast.success("Learners exam restart successfully");
      handleOpenClose();
          setTimeout(() => {
        navigate(`/admin/exam`);
      }, 2000);
    } catch (error) {
      console.error("Error changing learner status:", error);
      toast.error("Invalid password. Please try again.");
    }
  };

  return (
    <>
      <Fade in={true}>
        <div
          className={` ${classes.p1} ${classes.bgwhite}  ${classes.dflex}  ${classes.flexdirectioncolumn} `}
        >
          <Typography
            className={`${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
            variant="h6"
            display="inline"
          >
            Enter Your Password
          </Typography>
          <TextField
            name="password"
            type={showPassword ? "text" : "password"}
            variant="outlined"
            required
            placeholder="********"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleToggleShowPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <div
            className={`${classes.dflex} ${classes.justifyflexend} ${classes.mt1}`}
          >
            <Button
              className={`${classes.custombtnoutline}`}
              onClick={handleOpenClose}
            >
              Cancel
            </Button>
            <Button
              className={`${classes.custombtnblue}`}
              onClick={handleStatus}
              handleNaviagte
            >
              Submit
            </Button>
          </div>
        </div>
      </Fade>
    </>
  );
};

export default PlanPopup;
